import {
  REQUEST_USER_DETAILS,
  RECEIVE_USER_DETAILS,
  RECEIVE_PRODUCT_ASSETS,
} from '../constants/actionTypes';

export const initialState = {
  hasFetched: false,
  countryFeatures: [],
  subscription: null
};

/**
 * Handles redux state for current user details
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function userReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_USER_DETAILS: {
      return {
        ...state,
        id: action.id,
        hasFetched: false,
      };
    }
    case RECEIVE_USER_DETAILS: {
      return {
        ...state,
        hasFetched: true,
        ...action.userDetails,
      };
    }
    case RECEIVE_PRODUCT_ASSETS: {
      return {
        ...state,
        countryFeatures: action.payload.featuresByUserCountry,
        subscription: action.payload.name,
      };
    }
    default: {
      return state;
    }
  }
}

export default userReducer;
